import { __assign } from "tslib";
import { connect } from 'react-redux';
import { spreadLove } from './redux/actionCreators';
import LoveMeter from './LoveMeter';
import { getMeterState } from './redux/selectors';
import { getIsMobile } from '../publicSession/selectors';
var mapStateToProps = function (state, _a) {
    var itemId = _a.itemId, initialData = _a.initialData;
    return (__assign(__assign({}, getMeterState(state, itemId, initialData)), { isMobile: getIsMobile(state) }));
};
var mapDispatchToProps = {
    onChange: spreadLove,
};
export default connect(mapStateToProps, mapDispatchToProps)(LoveMeter);
//# sourceMappingURL=LoveMeter.container.js.map